import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const MapShell = styled.div`
  width: 100%;
  height: calc(100vh - 16rem);
  min-height: 30rem;
  border-radius: 1rem;
  overflow: hidden;
  background: ${tokens.surface.raised};
  position: sticky;
  top: 0;
  @media (max-width: 1100px) {
    position: static;
    height: 30rem;
  }
`

export const MapLoading = styled.div`
  width: 100%;
  height: calc(100vh - 16rem);
  min-height: 30rem;
  border-radius: 1rem;
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
`
